import { useTranslation } from 'react-i18next';
import styles from './PartnerResourcePanel.module.scss';
import { DrawerPanel } from '@dmc/ui';
import { ConnectivitySnackbar } from '@dmc/ui';
import Skeleton from 'react-loading-skeleton';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import usePartnerResource from './usePartnerResource';
import { PartnerResourceFileType } from '@cas/config/documents';

const onDownload = (uri?: string) => {
  if (uri) {
    window.open(uri, '_blank', 'noopener,noreferrer');
  }
};

export function PartnerResourcePanel() {
  const { t } = useTranslation();
  const { showDateOnlyFromIso } = useLocaleFormatter();

  const { doc, error } = usePartnerResource();

  return (
    <>
      <DrawerPanel
        header={
          <div className={styles.header}>
            <div className={styles.header__titleRow}>
              {doc ? doc.title : <Skeleton width="200px" height="36px" />}
            </div>
            <div className={styles.header__subtitleRow}>
              <div className={styles.subtitle}>
                {doc ? t(`DocType.${doc.documentType}`) : <Skeleton width="150px" />}
              </div>
              {doc ? (
                <div className={styles.timestamp}>{showDateOnlyFromIso(doc.date)}</div>
              ) : (
                <Skeleton width="150px" />
              )}
            </div>
          </div>
        }
        footer={
          doc && (
            <VdsButton
              onClick={_ => onDownload(doc.downloadUri)}
              variant="primary"
              size="medium"
              isFullWidth
            >
              {doc.fileType === PartnerResourceFileType.Link ? t('Open') : t('Download')}
              <VdsIcon
                slot="icon-left"
                svgIcon={doc.fileType === PartnerResourceFileType.Link ? 'open-icon' : 'download'}
              ></VdsIcon>
            </VdsButton>
          )
        }
      >
        {doc && <div className={styles.body}>{doc.description}</div>}
      </DrawerPanel>

      <ConnectivitySnackbar error={error} message={t('FetchDocError')} title={t('Error')} />
    </>
  );
}

export default PartnerResourcePanel;
